import styled from '@emotion/styled'

const CarouselWrapper = styled('div')`
  width: ${({ width }) => `${width}px`};
`
CarouselWrapper.displayName = 'CarouselWrapper'
export default CarouselWrapper
